export const validateDisplayOptions = (options: SeVaporOptions): void => {
    if (options.rentalApp?.location === "external" && !options.rentalApp.externalUrl) {
        throw new Error("When 'rentalApp.location' is 'external', 'rentalApp.externalUrl' must be provided.");
    }

    if (options.reservationApp?.location === "external" && !options.reservationApp.externalUrl) {
        throw new Error("When 'reservationApp.location' is 'external', 'reservationApp.externalUrl' must be provided.");
    }

    if (options.softReservationApp?.location === "external" && !options.softReservationApp.externalUrl) {
        throw new Error("When 'softReservationApp.location' is 'external', 'softReservationApp.externalUrl' must be provided.");
    }
};